import {
  GET_SEDES_REQUEST,
  GET_SEDES_SUCCESS,
} from '../../actions/constants/sedes/sedes.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 9999,
};

export default function sedesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_SEDES_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_SEDES_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      const { listado } = state;
      return {
        ...state, listado: [...listado, ...datos], total, loading: false, page, start, limit,
      };
    }

    default:
      return state;
  }
}
